type SignOutListener = () => void;

const listeners = new Set<SignOutListener>();

export const addSignOutListener = (listener: SignOutListener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const notifySignedOut = (): void => {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch (err) {
      console.error(err);
    }
  });
};
